import { IconPlaceholder } from '@juvare/common-web-ui/IconPlaceholder';
import CheckCircleOutline from '@mui/icons-material/CheckCircleOutline';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import { Box, Typography } from '@mui/material';
import React from 'react';
import { useMissionsTranslation } from '../hooks';
export const PendingRequests = ({ totalPendingParticipants }) => {
    const { t } = useMissionsTranslation();
    return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, flexGrow: 1, width: '100%' }, "data-test": 'pending-request' },
        React.createElement(IconPlaceholder, { status: totalPendingParticipants === 0 ? 'success' : 'warning' }, totalPendingParticipants === 0 ? React.createElement(CheckCircleOutline, null) : React.createElement(TimelapseIcon, null)),
        React.createElement(Typography, { variant: 'body2' }, t('shifts.pendingRequests', { totalPendingParticipants: totalPendingParticipants }))));
};
